import api from '@/api/api'

export default {
  namespaced: true,
  state: {
    categorias: [],
    videos: [],
    loading: true
  },
  mutations: {
    setData(state, data) {
      state.categorias = Object.assign(state.categorias, data.categorias)
      state.videos = Object.assign(state.videos, data.videos)
    },
    setLoading(state, data) {
      state.loading = data
    }
  },
  actions: {
    async getData({ commit }) {
      commit('setLoading', true)
      const response = await api.get('/main/get_data')
      commit('setData', response.data)
      commit('setLoading', false)
    }
  },
  getters: {
    getAllCategorias(state) {
      return state.categorias
    },
    getAllVideos(state) {
      return state.videos
    },
    getVideoById(state) {
      return id => {
        return state.videos.find(x => x.id == id)
      }
    },
    getCategoriaById(state) {
      return id => {
        return state.categorias.find(x => x.id == id)
      }
    },
    getNombreCategoriaById(state) {
      return id => {
        return state.categorias.find(x => x.id == id)
      }
    },
    getLoading(state) {
      return state.loading
    }
  }
}
